/**
 * Active Factoring Provider
 *
 * Fetch and update the active factoring provider for the current project.
 * Calls `/v1/factoring/active-provider` on main-service.
 */

import axios from 'axios'
import { ActiveFactoringProvider } from '@numeo/types-core'

export async function fetchActiveFactoringProvider(): Promise<{ main: ActiveFactoringProvider | null; sftp: ActiveFactoringProvider | null }> {
    const res = await axios.get<{
        success: true
        data: { activeFactoringProvider: ActiveFactoringProvider | null; activeSftpFactoringProvider: ActiveFactoringProvider | null }
    }>('/factoring/active-provider')
    return {
        main: res.data.data.activeFactoringProvider,
        sftp: res.data.data.activeSftpFactoringProvider,
    }
}
